import React, { FC, useEffect } from 'react';

import { useDispatch } from 'react-redux';

// Reset this container's own form; it previously reset the Environment slice instead.
import { actions } from 'containers/Inventory/InventoryContext/slice';

import { ContextWizard } from './index';

interface Props {}

export const CreateContext: FC<Props> = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.resetFormData());
  }, [dispatch]);

  return <ContextWizard actionType="Create" />;
};
